import React from 'react';

interface SectionWrapperProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function SectionWrapper({ title, description, children }: SectionWrapperProps) {
  return (
    <section>
      <h2 className="text-2xl font-bold mb-2 font-heading">{title}</h2>
      {description && (
        <p className="text-sm text-muted-foreground mb-6">{description}</p>
      )}
      <div className="space-y-8">{children}</div>
    </section>
  );
}
